<template>
  <div>
    <div class="search-container">
      <SearchInput
        placeholder="Search by name or keyword"
        name="search"
        v-model="searchTerm"
        class="search"
      />
    </div>
    <div id="benchmarks-big-table">
      <BenchmarksTable
        :data="rows"
        :columns="columns"
        :multiSelect="true"
        :loading="loading"
        :search="searchTerm"
        :sortKey="sortKey"
        :sortOrder="sortOrder"
        :items-per-page="rows.length"
        :isInPercentages="isInPercentages"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import BenchmarksTable from '../../BenchmarksTable.vue';
import { SearchInput } from '@mikmak/components';

export default {
  props: {
    rows: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sortKey: {
      type: String,
    },
    sortOrder: {
      type: Number,
    },
    isInPercentages: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BenchmarksTable,
    SearchInput,
  },
  data() {
    return {
      searchTerm: '',
    };
  },
  watch: {
    searchTerm(newVal) {
      this.$emit('updateSearchTerm', newVal);
    },
  },
};
</script>

<style scoped>
.search-container {
  width: 400px;
  padding: 16px;
}
</style>
